<template>
    <div class="co-papel-tabela">
        <v-data-table
            class="tabela-papeis"
            hide-default-footer
            :no-data-text="noDataText"
            :items-per-page="qtdLinhasTabela"
            :headers="headers"
            :items="papeis">

            <template v-slot:item.modelo="{ item }">
                {{ item.modelo ? 'Sim' : 'Não' }}
            </template>

            <template v-slot:item.status="{ item }">
                {{ item.ativo ? 'Ativo' : 'Inativo' }}
            </template>

            <template v-slot:item.acoes="{ item }">
                <v-layout class="acoes-tabela">
                    <v-tooltip top color="black" v-if="!item.modelo">
                        <template v-slot:activator="{ on }">
                            <v-icon class="botoes botoes-mobile" v-on="on" :disabled="ehPlanoFree" size="15px" @click="$emit('edit', item)"> mdi-pencil </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip top color="black" v-if="item.ativo">
                        <template v-slot:activator="{ on }">
                            <v-icon class="botoes" v-on="on" size="15px" :disabled="ehPlanoFree" @click="$emit('inativar', item)"> mdi-cancel </v-icon>
                        </template>
                        <span>Inativar</span>
                    </v-tooltip>

                    <v-tooltip top color="black" v-else>
                        <template v-slot:activator="{ on }">
                            <v-icon class="botoes" v-on="on" size="15px" :disabled="ehPlanoFree" @click="$emit('ativar', item)"> mdi-check </v-icon>
                        </template>
                        <span>Ativar</span>
                    </v-tooltip>
                </v-layout>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'PapelTabela',
    props: {
        papeis: {
            type: Array,
            required: true
        },
        qtdLinhasTabela: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Papel',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'nome',
                    divider: true
                },
                {
                    text: 'Padrão',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'modelo',
                    width: '30%',
                    divider: true
                },
                {
                    text: 'Status',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'status',
                    width: '30%',
                    divider: true
                },
                {
                    text: 'Ações',
                    align: 'center',
                    value: 'acoes',
                    sortable: false,
                    filterable: false,
                    width: '70px',
                    divider: true
                }
            ]
        }
    },
    computed: {
        ...mapGetters(['ehPlanoFree']),
        noDataText() {
            return 'Nenhum Papel encontrado.'
        }
    },
    methods: {}
}
</script>

<style lang="stylus">
.co-papel-tabela
    width 100%

    .v-input--selection-controls.v-input .v-label
        font-size 16px

    .tabela-papeis
        color var(--text-color-300)

        .acoes-tabela
            justify-content space-around

            .botoes
                color var(--text-color-200)

        thead th
            border-bottom thin solid rgba(0,0,0,.12)

        tbody td
            height 40px !important
            font-size 13px !important
            border-bottom thin solid rgba(0,0,0,.12)

@media (max-width: 720px)
    .co-papel-tabela
        .tabela-papeis
            .acoes-tabela
                justify-content right

                .botoes-mobile
                    margin-right 15px

            thead
                display none !important

            tbody tr
                border-bottom 1px solid var(--v-primary-lighten1) !important

                td
                    display block !important
                    text-align left !important
                    padding 5px 10px !important
                    max-height unset !important
                    height unset !important
                    justify-items left
</style>
